import { gql } from '@/__generated__';

export const StreamCardFragment = gql(`
fragment StreamCardFragment on Stream {
  id
  name
  description
  descriptionJson
  author {
    id
    username
    fullName
    avatar {
      key
    }
    __typename
  }
  label
  followersCount
  streamCategory
  isFeatured
  streamState
  streamType
  packageOnly
  apiAccessEnabled
  paidData {
    ...StripePriceFragment
  }
  subscription {
    cancelAt
    active
  }
}
`);
